import { watchEffect, computed } from "vue";
import { useState } from "#app";
export default function() {
  const cookieFirst = useState("cookie-first", () => null);
  const cookieFirstCategories = useState("cookie-first-categories", () => null);
  const cookieFirstServices = useState("cookie-first-services", () => null);
  const cookieFirstLayer = useState("cookie-first-layer", () => null);
  if (import.meta.client) {
    window.addEventListener("cf_init", () => {
      cookieFirst.value = window?.CookieFirst;
      cookieFirstServices.value = cookieFirst.value?.acceptedServices;
      cookieFirstCategories.value = cookieFirst.value?.consent;
    });
    window.addEventListener("cf_consent", (e) => {
      const event = e;
      cookieFirstCategories.value = event.detail;
    });
    window.addEventListener("cf_services_consent", (e) => {
      const event = e;
      cookieFirstServices.value = event.detail;
    });
    window.addEventListener("cf_layer_ready", (e) => {
      const event = e;
      cookieFirstLayer.value = event.detail;
    });
  }
  const init = (cb) => {
    watchEffect(() => {
      if (cookieFirst.value) {
        cb(cookieFirst.value);
        cookieFirstCategories.value = cookieFirst.value?.consent;
        cookieFirstServices.value = cookieFirst.value?.acceptedServices;
      }
    });
  };
  const onConsentCategoryChange = (cb) => {
    watchEffect(() => {
      if (cookieFirstCategories.value) {
        cb(cookieFirstCategories.value);
      }
    });
  };
  const onConsentServiceChange = (cb) => {
    watchEffect(() => {
      if (cookieFirstServices.value) {
        cb(cookieFirstServices.value);
      }
    });
  };
  const onLayerReady = (cb) => {
    watchEffect(() => {
      if (cookieFirstLayer.value) {
        cb(cookieFirstLayer.value);
      }
    });
  };
  const openPanel = (tab) => {
    if (cookieFirst.value) {
      cookieFirst.value.openPanel(tab);
    }
  };
  const closePanel = () => {
    if (cookieFirst.value) {
      cookieFirst.value.closePanel();
    }
  };
  const withdrawConsent = () => {
    if (cookieFirst.value) {
      cookieFirst.value.withdrawConsent();
    }
  };
  const updateConsent = (categories) => {
    if (cookieFirst.value) {
      cookieFirst.value.updateConsent(categories);
    }
  };
  const acceptCategory = (category) => {
    if (cookieFirst.value) {
      cookieFirst.value.acceptCategory(category);
    }
  };
  const acceptAllCategories = () => {
    if (cookieFirst.value) {
      cookieFirst.value.acceptAllCategories();
    }
  };
  const acceptPreselectedCategories = () => {
    if (cookieFirst.value) {
      cookieFirst.value.acceptPreselectedCategories();
    }
  };
  const declineAllCategories = () => {
    if (cookieFirst.value) {
      cookieFirst.value.declineAllCategories();
    }
  };
  const declineCategory = (category) => {
    if (cookieFirst.value) {
      cookieFirst.value.declineCategory(category);
    }
  };
  const acceptService = (service) => {
    if (cookieFirst.value) {
      cookieFirst.value.acceptService(service);
    }
  };
  const declineService = (service) => {
    if (cookieFirst.value) {
      cookieFirst.value.declineService(service);
    }
  };
  const changeLanguage = (language) => {
    if (cookieFirst.value) {
      cookieFirst.value.changeLanguage(language);
    }
  };
  const renderEmbeds = () => {
    if (cookieFirst.value) {
      cookieFirst.value.renderEmbeds();
    }
  };
  return {
    init,
    cookieFirst: computed(() => cookieFirst.value),
    categories: computed(() => cookieFirstCategories.value),
    services: computed(() => cookieFirstServices.value),
    onConsentCategoryChange,
    onConsentServiceChange,
    onLayerReady,
    openPanel,
    closePanel,
    withdrawConsent,
    updateConsent,
    acceptCategory,
    acceptAllCategories,
    acceptPreselectedCategories,
    declineAllCategories,
    declineCategory,
    acceptService,
    declineService,
    changeLanguage,
    renderEmbeds
  };
}
